<div
	class="circle-button-wrapper"
	(click)="handleClick($event)"
	(keydown.enter)="handleClick($event)"
	(keydown.space)="handleClick($event)"
	role="button"
	tabindex="0"
	aria-label="circle button"
>
	<div
		class="circle"
		[ngStyle]="style"
	>
		<ng-content></ng-content>
	</div>

	<span
		class="label"
		*ngIf="label"
	>
		{{ label }}
	</span>
</div>
